export default __webpack_public_path__ + "static/media/oliver_xl.894af000.jpg";